import React, {useState} from 'react'
import {useForm} from 'react-hook-form'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import WarningSvg from 'svgs/alert.svg'
import Buttons from '../Buttons'
import StepWrapper from '../StepStyled'
import {Link} from "gatsby";

const StepOne = ({setFormData, formData, step, setStep, setCookie, ...props}) => {
    const [success, setSuccess] = useState(false)
    const [error, hasErrors] = useState(false)
    const {FIRSTNAME, LASTNAME, EMAIL} = formData
    const {
        register,
        formState: {errors},
        handleSubmit,
    } = useForm({
        mode: 'onSubmit',
    })

    function onSubmit(data, e) {
        e.preventDefault()
        setFormData({
            ...formData,
            FIRSTNAME: data.FIRSTNAME,
            LASTNAME: data.LASTNAME,
            EMAIL: data.EMAIL,
        })

        addToMailchimp(data.EMAIL, {
            FIRSTNAME: data.FIRSTNAME,
            LASTNAME: data.LASTNAME,
            EMAIL: data.EMAIL
        }).then(message => {
            console.log(message)
            if (message.result === 'error') {
                hasErrors(message.msg)
            } else {
                setSuccess(true)
                setCookie('signup_open');
                setStep(step + 1)
            }
        })
    }

    return (
        <StepWrapper step={step} setStep={setStep} {...props}>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <div
                    className={errors.FIRSTNAME ? 'error input-wrapper' : ' input-wrapper'}
                >
                    <label htmlFor="FIRSTNAME">First Name*</label>
                    <div>

                        <input
                            type="text"
                            name="FIRSTNAME"
                            id="FIRSTNAME"
                            placeholder="First Name"
                            defaultValue={FIRSTNAME || null}
                            {...register('FIRSTNAME', {
                                required: 'Your first name is required',
                            })}
                        />
                        <WarningSvg/>
                    </div>
                </div>
                <div
                    className={errors.LASTNAME ? 'error input-wrapper' : ' input-wrapper'}
                >
                    <label htmlFor="LASTNAME">Last Name*</label>
                    <div>

                        <input
                            type="text"
                            name="LASTNAME"
                            id="LASTNAME"
                            placeholder="Last Name"
                            defaultValue={LASTNAME || null}
                            {...register('LASTNAME', {
                                required: 'Your last name is required',
                            })}
                        />
                        <WarningSvg/>
                    </div>
                </div>
                <div
                    className={errors.EMAIL ? 'error input-wrapper' : ' input-wrapper'}
                >
                    <label htmlFor="EMAIL">Email*</label>
                    <div>
                        <input
                            placeholder="Email*"
                            type="text"
                            name="EMAIL"
                            id="EMAIL"
                            defaultValue={EMAIL || null}
                            {...register('EMAIL', {
                                required: 'An email address is required',
                                pattern: {
                                    value:
                                        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                    message: 'Invalid email address',
                                },
                            })}
                        />
                        <WarningSvg/>
                    </div>
                </div>
                {error &&
                    <p className="error">{error}</p>}
                <div dangerouslySetInnerHTML={{ __html: props.blockSignupTerms}}/>
                <Buttons step={step} setStep={setStep}/>
            </form>
        </StepWrapper>
    )
}

export default StepOne
